import { jsxs as m, jsx as a } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { Container as d, Textarea as f } from "./styles.js";
import { useInputErrorMessages as l } from "../InputErrorMessage/useInputErrorMessages.js";
import { InputErrorMessage as x } from "../InputErrorMessage/InputErrorMessage.js";
const g = p(({ error: o, rows: s = 3, ...i }, t) => {
  const { isInvalid: e, errorMessages: r } = l(o);
  return /* @__PURE__ */ m(d, { children: [
    /* @__PURE__ */ a(
      f,
      {
        ...i,
        ref: t,
        rows: s,
        error: e,
        "aria-invalid": e,
        "aria-errormessage": r.length > 0 ? r.map((n) => n.id).join(" ") : void 0
      }
    ),
    r.length > 0 && /* @__PURE__ */ a(x, { children: r })
  ] });
});
g.displayName = "Textarea";
export {
  g as Textarea
};
//# sourceMappingURL=Textarea.js.map
